import { connect } from 'react-redux';
//
import TableActions from 'components/deal-list/table-actions/table-actions';
import { IStoreState } from 'store';
import { deleteMultipleDeals } from 'store/deals/actions';
import { clearModalContent, setModalContent } from 'store/modal/actions';
import { addDealsFromDashboard, evaluateDeals, setCompareDealIds } from 'store/deal-comparison/actions';

const mapStateToProps = ({ deals, dealEdit, fieldOptions }: IStoreState) => ({
  ...dealEdit,
  availableProducts: fieldOptions.products,
  searchFilter: deals.searchFilter,
});

const mapDispatchToProps = {
  addDealsFromDashboard,
  clearModalContent,
  deleteMultipleDeals,
  evaluateDeals,
  setModalContent,
  setCompareDealIds,
};

export default connect(mapStateToProps, mapDispatchToProps)(TableActions);
